<div class="ts1-overall-ob-summary">
	<button type="button" class="ts1-overall-ob-summary__header" (click)="toggleExpanded()">
		<span class="ts1-overall-ob-summary__title">OVERALL OB COUNT SUMMARY</span>
		<mat-icon class="ts1-overall-ob-summary__chevron" [class.ts1-overall-ob-summary__chevron--collapsed]="!expanded">
			expand_more
		</mat-icon>
	</button>

	@if (expanded) {
		<div class="ts1-overall-ob-summary__table-wrap">
			<table class="ts1-overall-ob-summary__table">
				<thead>
					<tr>
						<th scope="col">OB TYPE</th>
						<th scope="col">PF</th>
						<th scope="col">PM</th>
						<th scope="col">TOTAL</th>
					</tr>
				</thead>
				<tbody>
					@for (row of summary.rows; track row.obType) {
						<tr>
							<th scope="row">{{ row.obType }}</th>
							<td>{{ row.pf }}</td>
							<td>{{ row.pm }}</td>
							<td>{{ row.total }}</td>
						</tr>
					}
					<tr class="ts1-overall-ob-summary__total-row">
						<th scope="row">TOTAL</th>
						<td>{{ summary.totals.pf }}</td>
						<td>{{ summary.totals.pm }}</td>
						<td class="ts1-overall-ob-summary__grand-total">{{ summary.totals.total }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	}
</div>
